var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"package-access-notice",class:_vm.rootClass,attrs:{"role":"status"}},[_vm._v("\n\t"+_vm._s(_vm.labelPrefix)+": "+_vm._s(_vm.dateLabel)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }